<div [formGroup]="form">
  <div class="last-name" [ngStyle]="{'width':fnameShow ? 'calc(55% - 12.6px)' : 'calc(100% - 12.6px)' }">
    <label for="lname">Business or Last Name <span [ngStyle]="{'color': 'maroon'}">(required)</span></label>
    <input type="text" id="lname" name="lastcorpName" formControlName="lastcorpName" maxlength="255" aria-describedby="lname_error" [ngStyle]="{'text-transform': 'uppercase'}">
    <div id="lname_error" class="help-block" role="alert">
      <span *ngIf="form.get('lastcorpName').errors?.required && form.get('lastcorpName').touched">Enter Business or Last name</span>
      <span *ngIf="form.get('lastcorpName').errors?.pattern && form.get('lastcorpName').touched">Invalid characters in Business or Last name</span>
    </div>
  </div>
  <div class="space"></div>
  <div class="first-name" [ngStyle]="{'display':fnameShow ? 'block' : 'none' }" >
    <label for="fname">First Name</label>
    <input type="text" id="fname" name="fName" formControlName="fName" maxlength="255" aria-describedby="fname_error" [ngStyle]="{'text-transform': 'uppercase'}">
    <div id="fname_error" class="help-block" role="alert">
      <span *ngIf="form.get('fName').errors?.pattern && form.get('fName').touched">Invalid characters in First name</span>
    </div>
  </div>
</div>
